import Model from "@/app/models/Concerns/Model";
import PaginatedResponse from "@/app/models/Concerns/PaginatedResponse";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class Project extends Model {
    dossier_code!: string;
    name!: string;
    isah_order_number!: string;
    signed_checklists_count?: number;
    brands_count?: number;

    public static async show(id: number): Promise<Model> {
        const constructor = this as Function;
        const response: AxiosResponse<{ data: Model }> = await Client.get([this.table, id, 'show'].join('/'));

        // @ts-ignore
        return new constructor(response.data.data);
    }

    public static async open(page: number = 1, params: { [key: string]: any } = {}): Promise<PaginatedResponse<Model>> {
        return await this.index(page, params, this.table + '/open');
    }

    public static async brands(page: number = 1, params: { [key: string]: any } = {}): Promise<PaginatedResponse<Model>> {
        return await this.index(page, params, this.table + '/brands');
    }

    getTable(): string {
        return "projects";
    }
}
